import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import {
    getSystemAdminExcludedClinics,
    doLogout,
} from '../../actions';

import SysadminExcludedClinicListTable from '../../component/sysadmin/excludedclinic/list_table';
import { Grid, Button } from 'semantic-ui-react';
import CommonUtility from "../../utils/CommonUtility";
import { USER_TYPE, USER_ROLES } from '../../constants';

class SysadminExcludedClinicPage extends Component {
    componentDidMount() {
        if (this.props.user) {
            const { accessToken } = this.props.user;
            if (accessToken) {
                this.props.getSystemAdminExcludedClinics(accessToken, (result, error) => {
                    if (result) {
                        
                    } else if (error) {
                        console.log('getSystemAdminExcludedClinics error', error);
                        if (error.errorCode === 401) {
                            console.log('Unauthorized or token expire.');
                            this.props.doLogout();
                            this.props.history.push('/');
                        }
                    }
                });
            }
        }
    }
    render() {

        const isAdminOperation = CommonUtility.haveUserType( USER_TYPE.SYS_ADMIN, this.props.user ) && CommonUtility.haveRoles( [USER_ROLES.ADMIN_IT], this.props.user );

        return (
            <>
                <Grid columns="equal">
                    <Grid.Column>
                        { isAdminOperation &&  
                            <React.Fragment>
                                <Button as={Link} to="/systemadmin/excludedclinic/create" color="blue" icon="add" content="Create excluded clinic"/>
                            </React.Fragment>
                        }
                    </Grid.Column>
                </Grid>
                <SysadminExcludedClinicListTable />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
    };
}

export default withRouter(connect(mapStateToProps, {
    getSystemAdminExcludedClinics,
    doLogout,
})(SysadminExcludedClinicPage));